import http from '@/uteis/http'

export default class AutoCompleteService {
  constructor (url) {
    this.url = url
  }

  async pesquisar (filtro) {
    return new Promise((resolve, reject) => {
      http.get(this.url, { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get(this.url, { params: filtro }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
